interface DebouncedInstance {
  [key: symbol]: any;
}

export function Debounce(delay = 300): MethodDecorator {
  return (
    target,
    propertyKey,
    descriptor: PropertyDescriptor
  ): PropertyDescriptor => {
    const originalMethod = descriptor.value;
    const timerKey = Symbol();

    descriptor.value = function (this: DebouncedInstance, ...args: any[]) {
      clearTimeout(this[timerKey]);
      this[timerKey] = setTimeout(() => {
        originalMethod.apply(this, args);
      }, delay);
    };

    return descriptor;
  };
}
